// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".deleteWarningContent___6mQLv{padding:24px 0;line-height:24px}.sectionOne___iKbyL{padding-bottom:24px}.modalContainer___BUvzT{width:464px}\n", "",{"version":3,"sources":["webpack://./src/routes/ListManagement/components/DeleteListModal/DeleteListModal.css"],"names":[],"mappings":"AAAA,8BAAA,cAAA,CAEI,gBAAA,CAGJ,oBACI,mBAAA,CAGJ,wBACI,WAAA","sourcesContent":[".deleteWarningContent {\n    padding: 24px 0;\n    line-height: 24px;\n}\n\n.sectionOne {\n    padding-bottom: 24px;\n}\n\n.modalContainer {\n    width: 464px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteWarningContent": "deleteWarningContent___6mQLv",
	"sectionOne": "sectionOne___iKbyL",
	"modalContainer": "modalContainer___BUvzT"
};
export default ___CSS_LOADER_EXPORT___;
